import { JSX } from "react";
import Grid from "@mui/material/Grid";
import { Box, Typography, Link } from "@mui/material";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import ForumIcon from "@mui/icons-material/Forum";

const cardSx = (theme: { palette: { secondary: { main: string } } }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    p: 3,
    minHeight: 260,
    borderRadius: 3,
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    "&:hover": {
        transform: "translateY(-6px)",
        boxShadow: `0 12px 28px ${theme.palette.secondary.main}20`,
    },
});

export default function HowToWorks(): JSX.Element {
    return (
        <Box sx={{ flexGrow: 1, mt: 3, mb: 3, px: 2 }}>
            <Grid container spacing={3} sx={{ justifyContent: "space-around" }}>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Box sx={(theme) => cardSx(theme)}>
                        <ContactPhoneIcon fontSize="large" color="secondary" />
                        <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
                            Задайте вопрос
                        </Typography>
                        <Box>
                            <Typography variant="body2" color="text.secondary">
                                Позвоните тел.:{" "}
                                <Link href="tel:+7(918)081-80-23" color="primary" underline="hover">
                                    +7(918)081-80-23
                                </Link>
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                или напишите нам:{" "}
                                <Link href="mailto:shamovneva74@bk.ru" color="primary" underline="hover">
                                    shamovneva74@bk.ru
                                </Link>
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Box sx={(theme) => cardSx(theme)}>
                        <ForumIcon fontSize="large" color="secondary" />
                        <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
                            Ответим на вопросы
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Обсудим понравившихся животных, расскажем о каждом из них, условиях содержания, кормления и ухода
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}
